import React from 'react';
import { Modal, Spinner, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { Get } from '../../../../../utils/httpProvider';
import { DECUONGNGHIENCUU_API } from '../../../../../utils/apiUrl';
import ChamDiemDeCuongNghienCuu from './ChamDiemDeCuongNghienCuu';

const ChamDiemDeCuongModalWrapper = ({ show, handleClose, hoSoId }) => {
    // Fetch De Cuong by Ho So Id
    const { data: deCuongRes, isLoading } = useQuery(
        ['deCuong', hoSoId], 
        () => Get(DECUONGNGHIENCUU_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), 
        { enabled: !!hoSoId }
    );

    const dataDeCuong = deCuongRes?.data || {};

    return (
        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: 9999 }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title><i className="fas fa-star mr-2"></i> Chấm điểm đề cương nghiên cứu</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                {isLoading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2 text-muted">Đang tải thông tin đề cương...</p>
                    </div>
                ) : dataDeCuong?.id ? (
                    <ChamDiemDeCuongNghienCuu dataDeCuong={dataDeCuong} />
                ) : (
                    <div className="alert alert-warning text-center">
                        Sinh viên này chưa có thông tin đề cương nghiên cứu nên không thể chấm điểm.
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChamDiemDeCuongModalWrapper;
